<div class="file-container" [formGroup]="field.control" [transform]="toDbModel.bind(this)">
  <p class="controlName">{{ this.key | translate }}</p>
  <input type="file"
         multiple
         style="display: none"
         #fileInput
         [accept]="getFileInputAcceptString()"
         (input)="onFileInput()" />
  <div class="button-spinner-container">
    <button mat-raised-button
            color="accent"
            class="file-select-button"
            (click)="onClickFileInputButton($event)">
      <mat-icon>attach_file</mat-icon>
    </button>
    <div class="spinner-container" *ngIf="processingFiles">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <span class="file-name"
        *ngIf="fileControl.value === 0 && !processingFiles; else fileName">
    {{ 'noFileSelected' | translate }}
  </span>

  <ng-template #fileName>
    <div id="file-names">
      <ng-container *ngIf="fileControl.value !== null && fileControl.value !== []">
        <div *ngFor="let file of fileControl.value; index as i">
          <button mat-icon-button
                  (click)="onDeleteFileInput(i)">
            <mat-icon>delete</mat-icon>
          </button>
          <span class="file-name">
            {{ fileUploadNameControl.value[i] }}
          </span>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
